const TIME_12H_REGEX = /^(0?[1-9]|1[0-2]):([0-5]\d)\s*(AM|PM|am|pm)$/

export function isValid12h(input: string): boolean {
  return TIME_12H_REGEX.test(input.trim())
}

export function normalize12h(input: string): string {
  const trimmed = input.trim()
  const match = TIME_12H_REGEX.exec(trimmed)
  if (!match) return trimmed
  const [, hh, mm, period] = match
  const hour = parseInt(hh, 10)
  return `${hour}:${mm} ${period.toUpperCase()}`
}

export function to24h(input: string): string | null {
  const trimmed = input.trim()
  const match = TIME_12H_REGEX.exec(trimmed)
  if (!match) return null
  const [, hh, mm, period] = match
  let hour = parseInt(hh, 10)
  const isPm = period.toUpperCase() === 'PM'
  if (hour === 12) {
    hour = isPm ? 12 : 0
  } else if (isPm) {
    hour += 12
  }
  return `${String(hour).padStart(2, '0')}:${mm}`
}

export function to12h(input: string): string {
  const trimmed = input.trim()
  if (!trimmed) return ''
  if (TIME_12H_REGEX.test(trimmed)) return normalize12h(trimmed)
  const match = /^(\d{1,2}):(\d{2})$/.exec(trimmed)
  if (!match) return trimmed
  let hour = parseInt(match[1], 10)
  const minutes = match[2]
  const period = hour >= 12 ? 'PM' : 'AM'
  if (hour === 0) hour = 12
  else if (hour > 12) hour -= 12
  return `${hour}:${minutes} ${period}`
}

export function compareTimes(a: string, b: string): number {
  const aVal = to24h(a)
  const bVal = to24h(b)
  if (aVal === null || bVal === null) return 0
  if (aVal < bVal) return -1
  if (aVal > bVal) return 1
  return 0
}

export function isStartBeforeEnd(start: string, end: string): boolean {
  return compareTimes(start, end) < 0
}
